export const clearAllEventName = 'clearAll'
export const openDrawerEventName = 'openDrawer'
export const clearAllEvent = new Event(clearAllEventName)
export const openDrawerEvent = new Event(openDrawerEventName)
